import React from 'react';
import { observer } from 'mobx-react';
import { WordTypeStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class WordTypeCreate extends React.Component {

  onCreate = name => {
    WordTypeStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a word type name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default WordTypeCreate;
